// StoryMultiProgressBar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import media from '../style/media.js';
import { color } from '../style/variables.js';
const GROUP_COUNT = 50; // TODO: remote config
export class StoryMultiProgressBar extends React.PureComponent {
  getLocalProgress = ({ index, currentTime }) => {
    const { currentIndex, currentDuration } = this.props;
    const baseCount = Math.floor(currentIndex / GROUP_COUNT) * GROUP_COUNT;

    if (currentIndex === index + baseCount)
      return (currentTime / currentDuration).toFixed(9) * 100;

    if (currentIndex > index + baseCount) return 100;
    return 0;
  };

  getLocalGroupLength = () => {
    const { totalCount, currentIndex } = this.props;

    if (totalCount > GROUP_COUNT) {
      const isOnLastGroup =
        Math.floor(totalCount / GROUP_COUNT) <=
        Math.floor(currentIndex / GROUP_COUNT);

      if (!isOnLastGroup) {
        return GROUP_COUNT;
      } else {
        return totalCount % GROUP_COUNT;
      }
    } else {
      return totalCount;
    }
  };

  render() {
    const { currentTime } = this.props;
    return (
      <StyledStoryMultiProgressBar>
        {Array.from(Array(this.getLocalGroupLength())).map((val, index) => {
          const scaleX = this.getLocalProgress({
            index,
            currentTime,
          });
          const hasTransition = scaleX < 99 && scaleX > 1;
          return (
            <ProgressWrapper key={index}>
              <MessageProgressBar>
                <ProgressValue scaleX={scaleX} hasTransition={hasTransition} />
              </MessageProgressBar>
            </ProgressWrapper>
          );
        })}
      </StyledStoryMultiProgressBar>
    );
  }
}

StoryMultiProgressBar.propTypes = {
  totalCount: PropTypes.number,
  currentTime: PropTypes.number,
  currentDuration: PropTypes.number,
  currentIndex: PropTypes.number,
};

StoryMultiProgressBar.defaultProps = {
  totalCount: 0,
  currentTime: 0,
  currentDuration: 0,
  currentIndex: 0,
};

const StyledStoryMultiProgressBar = styled.div`
  position: absolute;
  top: 20px;
  right: 16px;
  left: 16px;
  pointer-events: auto;
  display: flex;
  ${media.mobile`
    top: 12px;
  `}
`;

const ProgressWrapper = styled.div`
  width: 100%;
  height: 4px;
  & + div {
    margin-left: 2px;
  }
`;

const MessageProgressBar = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: ${color.neutral['100_alpha_20']};
  overflow: hidden;
`;

const ProgressValue = styled.div.attrs(props => ({
  style: {
    width: `${props.scaleX}%`,
  },
}))`
  height: 100%;
  border-radius: 2px;
  background-color: ${color.neutral['100_alpha_80']};
  transform-origin: 0% 0%;
  will-change: width;

  ${({ hasTransition }) => (hasTransition ? transition : null)}
`;

const transition = css`
  transition: width 0.1s linear;
`;

export default StoryMultiProgressBar;
